import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=dc3b3e40&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=dc3b3e40&prod&lang=scss&scoped=true"
import style1 from "./Landing.vue?vue&type=style&index=1&id=dc3b3e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3b3e40",
  null
  
)

export default component.exports